/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { IconButton } from "@mui/material";
import { isArrayNotEmpty } from "utils/empty-exists";

const ScaleMethod = (props) => {
    
    const {
        selectScaleMethod,
        methods,
        selectedScaleMethod,
    } = props || {};
    
    const onSelectScaleMethod = (event, method, index) => {
        selectScaleMethod(event, method, index);
    };
    
    return (
        <>
            <div className='component-box in-page-scale-methods-container'>
                <>
                    <div className='component-box'>
                        <div className='in-page-scale-methods-buttons'>
                            {isArrayNotEmpty(methods) && methods.map((method, index) => {
                                const Component = method.icon;
                                const selectedClass = (selectedScaleMethod === method.value)
                                    ? "selected-position" : "unselected-position";
                                return (
                                    <div key={index}>
                                        <IconButton
                                            className={selectedClass}
                                            title={method.name}
                                            aria-label={method.name}
                                            size='large'
                                            onClick={(event) => onSelectScaleMethod(event, method.value, index)}
                                        ><Component/></IconButton>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

export default ScaleMethod;
